import clsx from 'clsx';
import type { ComponentProps, ReactNode } from 'react';
import { ECreateQuestionMode, useQuestionEditorContext } from '../context/create-question.context';
import { useAppSelector } from 'rtk/query/hooks';
import { selectQuestionMode } from 'rtk/questionEditorSelector';

interface Props extends ComponentProps<'div'> {
  leftContent: ReactNode;
  children?: ReactNode;
}

const CreateQuestionLayout = ({ leftContent, children, className, ...props }: Props) => {
  const { questionId } = useQuestionEditorContext();
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const inTemplate = [
    ECreateQuestionMode.InTemplateEdit,
    ECreateQuestionMode.InTemplateCreate,
    ECreateQuestionMode.InTemplateCopy,
  ].includes(mode);

  return (
    <div
      {...props}
      className={clsx(
        'bg-white',
        'rounded-md',
        [ECreateQuestionMode.InTemplateCreate, ECreateQuestionMode.InTemplateCopy].includes(mode) ? 'p-[24px]' : '',
        'flex min-h-0 flex-col',
        className,
      )}
    >
      {inTemplate ? (
        <div className="min-h-0 flex-1 overflow-y-auto">
          {leftContent}
          {children}
        </div>
      ) : (
        <>
          <div className="min-h-0 flex-1 overflow-y-auto">{leftContent}</div>
          <div className="shrink-0">{children}</div>
        </>
      )}
    </div>
  );
};

export default CreateQuestionLayout;
